var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-ui-section": "video-list" } },
    [
      _c("VideoCollectionVideoInitialIndexDataProvider", {
        attrs: {
          video: _vm.video,
          "video-collection-implementation":
            _vm.videoCollectionImplementationData
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var isLoading = ref.isLoading
              var initialVideoIndex = ref.data
              return [
                isLoading
                  ? _c("div", { staticClass: "p-4 text-center" }, [
                      _vm._v("\n        Loading video data...\n      ")
                    ])
                  : initialVideoIndex >= 0
                  ? _c("VsListRenderer", {
                      staticClass: "video-collection-list-renderer h-100",
                      attrs: {
                        "initial-item-index": initialVideoIndex,
                        "item-height": 64.25,
                        "item-fetcher": _vm.itemFetcher
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var videoCollectionVideo = ref.item
                              var itemIndex = ref.itemIndex
                              return [
                                videoCollectionVideo
                                  ? _c("VideoCollectionVideoPresenter", {
                                      attrs: {
                                        playing:
                                          videoCollectionVideo.id ===
                                          _vm.video.id,
                                        index: itemIndex,
                                        "video-collection-video": videoCollectionVideo
                                      },
                                      on: { click: _vm.handleDrawerItemClick }
                                    })
                                  : _c(
                                      "VideoCollectionVideoPlaceholderPresenter",
                                      { attrs: { index: itemIndex } }
                                    )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }